import { getMetadataStorage, validate } from 'class-validator';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { plainToModel } from './plain.model';
export function trValidationError(error, t) {
    if (error?.children?.length) {
        return error.children.map(c => {
            return {
                property: c.property,
                error: trValidationError(c, t),
            };
        });
    }
    if (!error?.constraints || !error.target)
        return;
    const errContstraint = Object.entries(error.constraints)[0][0];
    const storage = getMetadataStorage();
    const metas = storage.getTargetValidationMetadatas(error.target.constructor, '', true, false);
    const meta = metas.find(m => m.propertyName === error.property && m.name === errContstraint);
    if (!meta?.name)
        return;
    const args = {};
    meta.constraints
        ?.filter(arg => typeof arg !== 'function')
        .forEach((arg, i) => {
        args[`arg${i + 1}`] = arg;
    });
    const trKey = ('VALIDATION_' + meta.name.toUpperCase());
    return t(trKey, args) || trKey;
}
export function useValidateFormik(Model) {
    const { t } = useTranslation();
    return useCallback(async (values) => {
        const errors = await validate(plainToModel(Model, values));
        const rv = errors.reduce((obj, err) => {
            const trErr = trValidationError(err, t);
            if (trErr)
                obj[err.property] = trErr;
            return obj;
        }, {});
        return rv;
    }, [Model, t]);
}
